var ApplicationConstants = require('../constants/ApplicationConstants');
var ProductIds = require('../constants/ApplicationConstants').ProductIds;
var _ = require('lodash');

module.exports = {
    //Check dateString for actual valid date
    //dateString: DD/MM/YYYY
    isDateExist: function (dateString) {
        var dateJson = this.dateStringToJson(dateString);
        var date = this.dateStringToDate(dateString);

        if(!this.isValid(dateString)) {
            return false;
        }

        if (date.getFullYear() === dateJson.year && date.getMonth() + 1 === dateJson.month && date.getDate() === dateJson.day) {
            return true;
        }
        return false;
    },

    isValid: function (dateString) {
        const date = dateString.split('/');

        if (!isNaN(date[0]) && !isNaN(date[1]) && !(isNaN(date[2]))) {
            return true;
        }
        return false;
    },

    //returns object with day, month, year properties
    //dateString: DD/MM/YYYY
    dateStringToJson: function (dateString) {
        var comp = dateString.split('/');
        return { day: parseInt(comp[0], 10), month: parseInt(comp[1], 10), year: parseInt(comp[2], 10) }
    },

    //returns a new Date object from dateString
    //dateString: DD/MM/YYYY
    dateStringToDate: function (dateString) {
        var dateJson = this.dateStringToJson(dateString);
        return new Date(dateJson.year, dateJson.month - 1, dateJson.day);
    },

    //getMonth
    getMonth: function (dateString) {
        var dateJson = this.dateStringToJson(dateString);
        return dateJson.month;
    },

    //Calculate age
    //dateToday: Date object
    //birthDateString: DD/MM/YYYY
    getAge: function (dateToday, birthDateString) {
        var birthDate = this.dateStringToDate(birthDateString);
        var age = dateToday.getFullYear() - birthDate.getFullYear();
        var m = dateToday.getMonth() - birthDate.getMonth();
        //Birth day has not happened yet
        if (m < 0 || (m === 0 && dateToday.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    },

    isDateToday: function (dateToday, birthDateString) {
        var birthDate = this.dateStringToDate(birthDateString);
        var m = dateToday.getMonth() - birthDate.getMonth();
        if (birthDate.getFullYear() === dateToday.getFullYear() && m === 0 && birthDate.getDate() === dateToday.getDate()) {
            return true;
        }
        return false;
    },

    isFutureDate: function (dateToday, birthDateString) {
        var isFuturedate = this.dateStringToDate(birthDateString) - dateToday;

        if (this.isDateToday(dateToday, birthDateString) || isFuturedate > 0 || (this.getMonth(birthDateString) > 12 || this.getMonth(birthDateString) === 0)) {
            return true;
        }
        return false;
    },

    isDateLessThan2YearsFromToday: function (theDate) {
        const pastDate = this.dateStringToDate(theDate);
        const expiryDate = new Date(new Date().setFullYear(new Date().getFullYear() - 2));

        if(pastDate <= expiryDate) {
            return false;
        }
        return true;
    },

    //Note: Contribution matrix for RIP and Funding your product
    //To hide or show Personal, Spouse and Downsizer contribution
    eligibleContributionMatrix: function (age, dateOfBirth, downsizerContributionEligible) {
        var today = new Date(),
            isAge75Valid = dateOfBirth? this.isAge75Valid(today, dateOfBirth) : false,
            eligibleContribution = {
                hidePersonal: true,
                hideSpouse: true,
                hideDownsizer: !downsizerContributionEligible
            };

        if (age >= 0 ) {
            const hideOver75 = age > 75 || (age === 75 && !isAge75Valid);
            eligibleContribution.hidePersonal = hideOver75;
            eligibleContribution.hideSpouse = hideOver75;
        }
        return eligibleContribution;
    },

    //returns if Age 75 is valid
    //dateToday: Date object
    //birthDateString: DD/MM/YYYY
    isAge75Valid: function (dateToday, birthDateString) {
        var currentDate = new Date(dateToday);
        var mBirthDate = this.dateStringToDate(birthDateString || '');
        var endDate = new Date(dateToday.getFullYear(), mBirthDate.getMonth() + 1, 0);
        var ldate = new Date(endDate);
        var untilDate = new Date(ldate.setDate(endDate.getDate() + 28));
        var untilDateMonth = !untilDate.getMonth()? 12 : untilDate.getMonth();
        untilDate.setHours(23);
        untilDate.setMinutes(59);
        untilDate.setSeconds(59);

        if (untilDate >= currentDate) {
            if (untilDateMonth === currentDate.getMonth()+1 && mBirthDate.getDate() <= currentDate.getDate()) {
                return true;
            } else if (untilDateMonth < currentDate.getMonth()+1 && currentDate.getDate() <= untilDate.getDate()) {
                return true;
            }
        }

        return false;
    },

    dateToString: function(date) {
        if(Object.prototype.toString.call(date) === '[object Date]' && isFinite(date)) {
            var day = date.getDate() < 10? '0' + date.getDate() : date.getDate(),
                year = date.getFullYear(),
                month = date.getMonth()+1;

            if (month < 10) {
                month = '0' + month;
            }
            return day + '/' + month + '/' + year;
        } else {
            return '';
        }
    },

    isCurrentYear: function(year) {
        var date = new Date();
        return !isNaN(year) && year? date.getFullYear() === year : false;
    },

    //Birth date validations:
    //  1.  Birth year should be equal or greater than 1900. (Even 1899 is not accepted.)
    //  2.  Date cannot be a future date.
    //  3.  Investor’s age should be 18 years or older (Product=PENSION)
    //  4.  Investor’s age should be 16 years or older (Product=SUPER)
    isBirthDateValid: function (dateString, productId) {
        if (!dateString) {
            return false;
        }

        if (dateString.length !== 10) {
            return false;
        }
        var dateJson = this.dateStringToJson(dateString);
        if (dateJson.year < 1900) {
            return false;
        }

        if (!this.isDateExist(dateString)) {
            return false;
        }

        if (this.dateStringToDate(dateString) > new Date()) {
            return false;
        }

        if (this.isDateToday(new Date(), dateString)) {
            return false;
        }

        if (productId) {
            return this.isAgeValid(dateString, productId);
        }

        return true;
    },

    isAgeValid: function (dateString, productId) {
        var minAge = productId === ProductIds.PENSION ? 18 : 0;
        var age = this.getAge(new Date(),dateString);
        var isFutureDate = this.isFutureDate(new Date(), dateString);
        if (!isFutureDate && ((isNaN(age) || age - minAge) < 0)){
            return false; 
        }     
        return true; 
    },

    getDayOfTheWeek: function(dateString) {
        let dateJson = this.dateStringToJson(dateString),
            date = new Date(dateJson.year, dateJson.month-1, dateJson.day),
            daysOfTheWeek = _.clone(ApplicationConstants.DaysOfTheWeek);

        return !this.isDateExist(dateString) || !this.isValid(dateString)? '' : daysOfTheWeek[date.getDay()];
    },

    getMonthName: function(month) {
        let monthNames = _.clone(ApplicationConstants.MonthNames);
        return !isNaN(month) && month >= 0 && month <= 11? monthNames[month] : '';
    },

    dateToDetailedString: function(dateString) {
        let dateJson = this.dateStringToJson(dateString),
            dayOfTheWeek = this.getDayOfTheWeek(dateString),
            month = this.getMonthName(dateJson.month-1);

        if (!this.isDateExist(dateString) || !this.isValid(dateString)) {
            return '';
        }

        if (dayOfTheWeek !== '') {
            return dayOfTheWeek + ', ' + dateJson.day + ' ' + month + ' ' + dateJson.year;
        }
    },

    oneYearFromNow: function(currentDate = new Date()) {
        let isLeapYear = new Date(currentDate.getFullYear(), 1, 29).getMonth() === 1,
            day = isLeapYear && currentDate.getMonth() === 1 && currentDate.getDate() >= 29? 28 : currentDate.getDate();

        return this.dateToDetailedString(this.dateToString(new Date(currentDate.getFullYear()+1, currentDate.getMonth(), day)));
    },

    getCurrentDate:function() {
        const today = new Date();
        const date = today.getDate()+'/'+(today.getMonth()+1)+'/'+ today.getFullYear();
        const time = today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
        return date+' '+time;
    },

    convertSecondsToMMSS: function(seconds) {
        if (isNaN(seconds) || !isNaN(seconds) && seconds <= 0) {
            return '';
        }
        const mm = Math.floor(seconds / 60);
        const ss = seconds % 60;
        let converted = mm.toString() + ':';
        converted += ss < 10? '0' + ss.toString() : ss;
        return converted;
    }
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./utils/DateTime.js